import { useEffect, useState } from 'react';
import CalculatorModal from '@/components/CalculatorModal';

/**
 * GlobalBasicCalculator — Round 95bs (Jun 2026)
 *
 * Mounted ONCE at the App level so the `open-basic-calculator`
 * window event reaches a listener no matter which page the user
 * is on. Previously the listener only lived in Dashboard.js, which
 * meant the Stock Modal's "Calculator" action-line link silently
 * failed when the modal was opened from any non-Dashboard page
 * (Kings/Aristocrats/Achievers, Screener, Sector Buy lists, How To,
 * Learn guides, Glossary). With this component mounted at the
 * BrowserRouter level, the listener is page-agnostic.
 *
 * The Dashboard's Tool Box "Basic Calculator" tile and the Capital
 * Tracker card now also dispatch `open-basic-calculator` (instead
 * of setting local Dashboard state) so there's one canonical path
 * to opening the calculator from anywhere in the app.
 */
export default function GlobalBasicCalculator() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('open-basic-calculator', handler);
    return () => window.removeEventListener('open-basic-calculator', handler);
  }, []);

  return <CalculatorModal open={open} onClose={() => setOpen(false)} />;
}
